var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgMestergruppen = function SvgMestergruppen(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 56,
    viewBox: "0 0 95 56",
    width: 95,
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m278.892 366.182v-11.182h-47.472l-19.757 19.746-19.757-19.746h-7.906v55.327h11.185v-36.241l16.478 16.471 16.479-16.471v32.941l.008 3.3h50.742v-33.593h-11.184v22.408h-28.375v-32.96z",
    fill: "#0500a8",
    fillRule: "evenodd",
    transform: "translate(-184 -355)"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgMestergruppen);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "mestergruppen.6f80a733489e43b041da51a0310cdd6a.svg";